import * as React from 'react';
import PropTypes from 'prop-types';
import IconButton from '@base/IconButton/IconButton';
import Drawer from '@material-ui/core/Drawer';
import styled from 'styled-components';
import ArrowBack from '@icon/ArrowBack';
import P1 from '@base/P1/P1';
import H3 from '@base/H3/H3';
import GoalCard from './GoalCard';

const StyledDrawer = styled(Drawer)`
  display: none;
  @media (max-width: 47.95em) {
    display: block;
    &.MuiDrawer-root,
    &.MuiDrawer-root > .MuiBackdrop-root {
      background-color: transparent;
      top: 56px !important;
    }
    &.MuiDrawer-root > .MuiPaper-root {
      top: 48px;
      width: 100%;
      background: #fff;
      box-shadow: none;
    }
  }
`;

const Container = styled.div`
  padding: 0;
  margin-top: 24px;
`;

const TitleWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 24px;
  padding: 0 16px;
`;

const BackButton = styled(IconButton)`
  margin-right: 12px;
`;

const Goals = styled.div`
  margin: 24px 0 112px;
  padding: 0 16px;
  & > div:last-child {
    margin-bottom: 0;
  }
`;

const StyledH3 = styled(H3)`
  padding: 0 16px;
`;

function ChooseGoal({
  chooseGoal,
  resetChooseGoal,
  me,
  meModal,
  followedGoals,
  removeGoalAction,
  onGoalCardClick
}) {
  const handleGoalCardClick = ({
    isMyGoal,
    isSubscribedGoal,
    isFollowedGoal,
    goal
  }) => {
    onGoalCardClick({ isMyGoal, isSubscribedGoal, isFollowedGoal })(goal);
  };
  return (
    <StyledDrawer open={!!chooseGoal} onClose={resetChooseGoal} anchor="right">
      {chooseGoal ? (
        <Container>
          <TitleWrapper>
            <BackButton bgColor="#fff" hovDisabled onClick={resetChooseGoal}>
              <ArrowBack size="16px" color="#3C4852" />
            </BackButton>
            <P1>Choose your goal</P1>
          </TitleWrapper>
          <StyledH3>{chooseGoal.name}</StyledH3>
          <Goals>
            {chooseGoal.children.map((goal) => {
              const isMyGoal = goal.uid === 'my-goal';
              const isSubscribedGoal = meModal.hasActiveSubscriptionToGoal(
                me,
                goal.uid
              );
              const isFollowedGoal =
                followedGoals.filter(
                  (followedGoal) => followedGoal.uid === goal.uid
                ).length > 0;
              return (
                <GoalCard
                  key={goal.uid}
                  goal={goal}
                  isMyGoal={isMyGoal}
                  isSubscribedGoal={isSubscribedGoal}
                  isFollowedGoal={isFollowedGoal}
                  removeGoalAction={removeGoalAction}
                  onClick={() => {
                    handleGoalCardClick({
                      isMyGoal,
                      isSubscribedGoal,
                      isFollowedGoal,
                      goal
                    });
                  }}
                />
              );
            })}
          </Goals>
        </Container>
      ) : null}
    </StyledDrawer>
  );
}

export default ChooseGoal;

ChooseGoal.propTypes = {
  chooseGoal: PropTypes.objectOf(PropTypes.any),
  me: PropTypes.objectOf(PropTypes.any).isRequired,
  meModal: PropTypes.objectOf(PropTypes.any).isRequired,
  followedGoals: PropTypes.arrayOf(PropTypes.string),
  resetChooseGoal: PropTypes.func.isRequired,
  removeGoalAction: PropTypes.func.isRequired,
  onGoalCardClick: PropTypes.func.isRequired
};

ChooseGoal.defaultProps = {
  chooseGoal: null,
  followedGoals: []
};
